/**
 * The Voice row's second line while a wanted Pocket voice language is not yet
 * installed: how far its download is, or that it failed, with a Retry.
 * `null` once every wanted language is installed.
 */
import type { ReactNode } from "react";

import { Button } from "@/components/ui";
import type { PocketLanguage } from "@/desktop/pocket-voice";
import type { PocketVoiceDownload } from "@/desktop/use-pocket-voice-download";

const RETRY_LINK =
  "h-auto rounded-control-sm px-0 py-0 text-appkit-small font-medium";

const VOICE_NAMES: Record<PocketLanguage, string> = {
  en: "English voice",
  de: "German voice",
  fr: "French voice",
  es: "Spanish voice",
  nl: "Dutch voice",
  cs: "Czech voice",
  el: "Greek voice",
  et: "Estonian voice",
  zh: "Chinese voice",
  kokoro: "Italian, Portuguese, Hindi and Japanese voice",
};

export function pocketVoiceLine(
  download: PocketVoiceDownload,
  onRetry: () => void,
): ReactNode {
  if (download.kind === "downloading") {
    return (
      <span data-testid="voice-pocket-downloading">
        {VOICE_NAMES[download.language]} downloading… {download.percent}%
      </span>
    );
  }
  if (download.kind === "failed") {
    return (
      <span data-testid="voice-pocket-failed">
        {VOICE_NAMES[download.language]} couldn&apos;t download ·{" "}
        <Button
          type="button"
          variant="link"
          className={RETRY_LINK}
          onClick={onRetry}
          data-testid="voice-pocket-retry"
        >
          Retry
        </Button>
      </span>
    );
  }
  return null;
}
